import { CookieCategory } from '@amzn/awscat-cookie-management';
import { JsonObject, JsonProperty } from 'json2typescript';

import { GetLocalStorage, SetLocalStorage } from '../contexts/CookieConsentContext';

const recentPortfolioKey = 'recent-portfolios:portfolios';

@JsonObject('RecentPortfoliosLocalStorage')
export class RecentPortfoliosLocalStorage {
    public static create(recentPortfoliosLocalStorage: RecentPortfoliosLocalStorage): RecentPortfoliosLocalStorage {
        return Object.assign(new RecentPortfoliosLocalStorage(), recentPortfoliosLocalStorage);
    }
    @JsonProperty('rp')
    rp: string[] = [];
}
class LocalStorage {
    /**
     * Returns an array of portfolio id strings from local storage
     * @returns 
     */
    public static getRecentPortfolios(getLocalStorage: GetLocalStorage): string[] {
        const rpItem: string = getLocalStorage(recentPortfolioKey);
        let parsedRpItem: RecentPortfoliosLocalStorage = new RecentPortfoliosLocalStorage();
        if (rpItem) {
            try {
                parsedRpItem = JSON.parse(rpItem);
            } catch (err) {
                console.log(err);
            }
        }
        return parsedRpItem.rp || [];
    }
 
    /**
     * Saves the given list of portfolio id strings to local storage
     * @param recentPortfolioIds 
     */
    public static setRecentPortfolios(recentPortfolioIds: string[], setLocalStorage: SetLocalStorage): void {
        const str = JSON.stringify(RecentPortfoliosLocalStorage.create({rp: recentPortfolioIds}));
        setLocalStorage(recentPortfolioKey, str, [CookieCategory.Functional]);
    }

}

export default LocalStorage;
